import { CellValueChangedEvent } from 'ag-grid-community';
import { useCallback } from 'react';
import { HRM1030_R01FileDto, HRM1030_R01TrainingDto } from '../Dto_HRM1030_R01';
import { useHRM1030_R01Store } from '../Store_HRM1030_R01';

/**
 * 교육·첨부 셀 변경을 해당 목록에 반영하고 수정 상태를 기록한다(HRM1040 CellChange와 같은 방식).
 * @returns 교육 그리드와 첨부 그리드의 onCellValueChanged 함수
 */
export const useHRM1030_R01CellChange = () => {
    // 화면 Store에서 valueIndex로 교육·첨부 행을 교체하는 함수를 가져온다.
    const { updateHRM1030_R01TrainingList, updateHRM1030_R01FileList } = useHRM1030_R01Store();
    /**
     * 교육 셀 값이 실제로 바뀌었을 때만 행을 수정 상태로 저장한다.
     * @param event 변경된 셀 정보
     */
    const handleTrainingCellChange = useCallback((event: CellValueChangedEvent<HRM1030_R01TrainingDto>) => {
        if (!event.data || event.oldValue === event.newValue) return;
        updateHRM1030_R01TrainingList(event.data.valueIndex, { ...event.data, isModified: true });
    }, [updateHRM1030_R01TrainingList]);
    /**
     * 첨부 비고가 실제로 바뀌었을 때만 행을 수정 상태로 저장한다.
     * @param event 변경된 셀 정보
     */
    const handleFileCellChange = useCallback((event: CellValueChangedEvent<HRM1030_R01FileDto>) => {
        if (!event.data || event.oldValue === event.newValue) return;
        updateHRM1030_R01FileList(event.data.valueIndex, { ...event.data, isModified: true });
    }, [updateHRM1030_R01FileList]);
    return { handleTrainingCellChange, handleFileCellChange };
};
